import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as PhysicalIcon } from "Assets/icons/physicalMarket.svg";
import { ReactComponent as DerivativeIcon } from "Assets/icons/derivativeMarket.svg";
import { ReactComponent as OtherTradableIcon } from "Assets/icons/otherTradableSecurities.svg";
import { useNavigate } from 'react-router-dom';
import SubMarketIcon from 'Assets/Images/subMarket.png'
const Prospectus = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;


    return (
        <div className="megaMenuContent">
            <div className="row">
                <div className="col-3 border-left">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <PhysicalIcon width={"65px"} height={"65px"} className="text-blue" />
                        <a href="/Listing/Prospectus/PhysicalMarket/OilAndGas" className="btn prospectusBtn text-blue text-center">
                            {t('physical_market') }
                        </a>
                    </div>
                    <div className="d-flex flex-column">
                        <a href="/Listing/Prospectus/PhysicalMarket/OilAndGas" className="tradesFeeItems py-2 px-4 w-100 mb-3">
                            {t('oilAndGas')}
                        </a>
                        <a href="/Listing/Prospectus/PhysicalMarket/Power" className="tradesFeeItems py-2 px-4 w-100 mb-3">
                            {t('electricity')}
                        </a>
                        <a href="/Listing/Prospectus/PhysicalMarket/OtherEnergyCarriers" className="tradesFeeItems py-2 px-4 w-100">                            
                            {t('otherEnergyCarriers')}
                        </a>
                    </div>
                </div>
                <div className="col-3 border-left">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <DerivativeIcon width={"65px"} height={"65px"} className="text-blue" />
                        <a href="/Listing/Prospectus/DerivativeMarket/ParallelSalaf" className="btn prospectusBtn text-blue text-center">
                            {t('derivative_market')}
                        </a>
                    </div>
                    <div className="d-flex flex-column">
                        <a href="/Listing/Prospectus/DerivativeMarket/ParallelSalaf" className="tradesFeeItems py-2 px-4 w-100 mb-3">
                            {t('parallelSalamContract')}
                        </a>
                        <a href="/Listing/Prospectus/DerivativeMarket/Futures" className="tradesFeeItems py-2 px-4 w-100 mb-3">
                            {t('futuresContract')}
                        </a>
                        <a href="/Listing/Prospectus/DerivativeMarket/Options" className="tradesFeeItems py-2 px-4 w-100">
                            {t('optionContract')}
                        </a>
                    </div>
                </div>
                <div className="col-3 border-left">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <OtherTradableIcon width={"65px"} height={"65px"} className="text-blue" />
                        <a href="/Listing/Prospectus/OtherTradableSecuritiesProspectus/ETF" className="btn prospectusBtn text-blue text-center">
                            {t('other_securities_market')}
                        </a>
                    </div>
                    <div className="d-flex flex-column">
                        <a href="/Listing/Prospectus/OtherTradableSecuritiesProspectus/ETF" className="tradesFeeItems py-2 px-4 w-100 mb-3">
                            {t('etf')}
                        </a>
                        <a href="/Listing/Prospectus/OtherTradableSecuritiesProspectus/CapacityCertificateBoard" className="tradesFeeItems py-2 px-4 w-100 mb-3">
                            {t('capacityCertificateBoard')}
                        </a>
                        <a href="/Listing/Prospectus/OtherTradableSecuritiesProspectus/EnergySavingCertificateBoard" className="tradesFeeItems py-2 px-4 w-100">
                            {t('energySavingCertificateBoard')}
                        </a>
                    </div>
                </div>
                <div className="col-3">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <img src={SubMarketIcon} width={"65px"} height={"65px"} className="text-blue" />
                        <a href="/Listing/Prospectus/SubMarket/SubMarket" className="btn prospectusBtn text-blue text-center">
                            {t('sub_market')}
                        </a>
                    </div>
                    <div className="d-flex flex-column">
                        <a href="/Listing/Prospectus/SubMarket/SubMarket" className="tradesFeeItems py-2 px-4 w-100 mb-3">
                            {t('secondaryMarketProspectuses')}
                        </a>
                        <a href="/Listing/Prospectus/SubMarket/History" className="tradesFeeItems py-2 px-4 w-100 mb-3">
                            {t('records')}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Prospectus;
